<template>
  <div
    class="flex w-[160px]"
    :class="[
      { 'opacity-40': props.data.disabled }
    ]"
  >
    <div class="flex-0 w-[45px]">
      <button
        type="button"
        :disabled="props.data.disabled"
        class="flex justify-center items-center w-full h-10 bg-white border border-gray-300 border-r-0 rounded-tl rounded-bl outline-none cursor-pointer text-gray-600 hover:text-gray-900 disabled:cursor-default disabled:bg-surface-100 disabled:text-gray-400"
        @click="decrement"
      >
        <span class="block w-2.5 h-0.5 bg-current"></span>
      </button>
    </div>

    <div class="flex-1 w-[calc(100%-80px)]">
      <InputMask
        :id="props.data.id"
        v-model="quantity"
        class="!h-10 rounded-none text-center border-gray-300 ring-transparent focus:ring-transparent disabled:text-gray-400"
        :class="[
          props.data.disabled ? '!bg-surface-100' : '',
          props.data.errorMessage ? 'invalid' : 'valid'
        ]"
        :mask="props.data.maska"
        slot-char=""
        :auto-clear="false"
        :disabled="props.data.disabled"
        :autocomplete="props.data.name"
        :placeholder="props.data.placeholder"
        :min="props.data.min"
        :max="props.data.max"
        @change="handleInput(quantity)"
      />
    </div>

    <div class="flex-0 w-[45px]">
      <button
        type="button"
        :disabled="props.data.disabled"
        class="relative flex justify-center items-center w-full h-10 bg-white border border-gray-300 border-l-0 rounded-tr rounded-br outline-none cursor-pointer text-gray-600 hover:text-gray-900 disabled:cursor-default disabled:bg-surface-100 disabled:text-gray-400"
        @click="increment"
      >
        <span class="absolute block w-2.5 h-0.5 bg-current"></span>
        <span class="absolute block w-0.5 h-2.5 bg-current"></span>
      </button>
    </div>
  </div>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: Object,
    default: null
  }
})

const min = props.data.min ? parseInt(props.data.min) : 1
const max = parseInt(props.data.max)
const quantity = ref(min)

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Main Logic
*/
onMounted(() => {
  quantity.value = props.data.formData[props.data.name] 
    ? props.data.formData[props.data.name] * 1 
    : min

  if (!quantity.value) {
    quantity.value = 1
  }
})

/**
* Handle Input
*/
const handleInput = (newQuantity) => {
  let returnQuantity = newQuantity * 1

  if (parseInt(quantity.value) < parseInt(min) || returnQuantity < parseInt(min) || returnQuantity < 1) {
    returnQuantity = min
  } else if (parseInt(quantity.value) > max || returnQuantity > max) {
    returnQuantity = max
  }

  quantity.value = returnQuantity

  emit('returnData', quantity.value)
}

/**
* Increment Quantity
*/
const increment = () => {
  if (quantity.value * 1 + 1 <= max) {
    const newQuantity = quantity.value * 1 + 1
    handleInput(newQuantity)
  }
}

/**
* Decrement Quantity
*/
const decrement = () => {
  if (quantity.value * 1 - 1 >= min) {
    const newQuantity = quantity.value * 1 - 1
    handleInput(newQuantity)
  }
}
</script>


